{
    "cl_header": {
      "logout": "Uitloggen"
    },
    "cl_applauncher": {
      "seemoreapplications": "Meer applicaties bekijken",
      "spinner": "Laden...",
      "noApps": "Geen apps beschikbaar"
    },
    "cl_alert": {
      "dismiss_all": "Alles verwerpen",
      "notfication_title": "Meldingen",
      "no_notifications": "Geen meldingen"
    },
    "cl_side_nav": {
      "support": "Ondersteuning",
      "legal": "Legaal"
    },
    "cl_company_switcher": {
      "search_company": "Naam organisatie",
      "loading": "laden"
    },
    "applauncher": {
      "spinner": "Laden..."
    }
  }